module.exports = __webpack_public_path__ + "img/complete_header_bg.8ff5c4b0.png";